import network from '@/services/network';
import { ActivityLogFilters, ReminderFeedEntry, SpatieActivityLogResponse } from '@/types';
import { ErrorResponse } from '@/utils';

const getActivityLog = async (filters: ActivityLogFilters = {}): Promise<SpatieActivityLogResponse> => {
  try {
    const params: Record<string, string | number> = {};
    if (filters.causer_id) params.causer_id = filters.causer_id;
    if (filters.subject_type) params.subject_type = filters.subject_type;
    if (filters.event) params.event = filters.event;
    if (filters.log_name) params.log_name = filters.log_name;
    if (filters.from) params.from = filters.from;
    if (filters.to) params.to = filters.to;
    if (filters.page) params.page = filters.page;
    if (filters.per_page) params.per_page = filters.per_page;

    const { data } = await network.get<SpatieActivityLogResponse>('/activity-log', { params });
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const getDealActivityLog = async (dealId: number, page = 1, perPage = 50): Promise<SpatieActivityLogResponse> => {
  try {
    const { data } = await network.get<SpatieActivityLogResponse>(`/deals/${dealId}/activity-log`, {
      params: { page, per_page: perPage },
    });
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const getDealReminderFeed = async (dealId: number): Promise<ReminderFeedEntry[]> => {
  try {
    const { data } = await network.get<{ data: ReminderFeedEntry[] }>(
      `/deals/${dealId}/reminder-feed`,
    );
    return data.data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

/**
 * Kunden-Verlauf (Auftrag Alex 07.08.2026, Teil 3+4): dieselben
 * Termin-Ereignisse wie im Case-Feed, aber ueber ALLE Faelle des Kunden, plus
 * die Stammdaten-Aenderungen. Gleicher Rueckgabetyp — deshalb rendert beides
 * dieselbe Komponente.
 */
const kundenVerlauf = async (customerId: number): Promise<ReminderFeedEntry[]> => {
  try {
    const { data } = await network.get<{ data: ReminderFeedEntry[] }>(
      `/customers/${customerId}/verlauf`,
    );
    return data.data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const activityLogApi = { getActivityLog, getDealActivityLog, getDealReminderFeed, kundenVerlauf };
export default activityLogApi;
